import {createAction} from 'web-app/util/redux/typed-action-helpers';
import type BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

export const {action: fetchBehaviorsSuccess} = createAction(
    'UPDATE_BEHAVIORS_SUCCESS',
    (institutionId: string, behaviors: BehaviorsCollection) => ({
        institutionId,
        behaviors,
    }),
);
